import styled from 'styled-components'

const MyDiv = styled.div`
.mb-2{
    margin-bottom:15px;
  }
  .mb-0{
    margin-bottom:0px;
  }
  .placeholder_text input{
    font-size: 14px;
    font-family: "Arial";
    color: #555;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
.search_box{
  margin-bottom: 4px;
  width: 98%;
  margin-left: 4px;
  margin-top: -4px;
}
.placeholder_text .Mui-disabled{
  -webkit-text-fill-color: #555;
  background: #eee;
  cursor: not-allowed;
}
`
export default MyDiv
